import { fileUpload, getRequest, postRequest } from './request'
// 商户列表
export function optionsList(params){
  return getRequest("/business/configure/info",
      params
)
}